module.exports = __webpack_public_path__ + "static/img/ftp.a1681a12.png";